import React, { useEffect, useState } from 'react';
import Product from "@system/config/product";
import $ from "jquery";
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';

const ProductDetailDescriptionTab = (props) => {
  const { translation: t } = System;
  const { productDetail } = props;
  const [productData, setProductData] = useState([]);
  const [ECCNData, setECCNData] = useState([]);
  const [ascDesField, setAscDesField] = useState({});
  const [sortBy, setSortBy] = useState('');
  const [selectedValues, setSelectedValues] = useState({});

  const goToProductListing = () => {
    let encodedUrl = Helper.safeBase64Encode(selectedValues);
    // let encodedUrl = btoa(selectedValues);
    window.location.href = Product.getProductListingPageRouteURL() + '?' + $.param({
      go: encodedUrl
    });
  };

  useEffect(() => {
    if (productDetail?.Attributes.length > 0) {
      setProductData(productDetail.Attributes);
    }
    if (productDetail) {
      const ECCNInfo = [];
      if (productDetail?.ECCNCode) {
        ECCNInfo.push({ Name: 'ECCN', Value: productDetail.ECCNCode })
      }
      if (productDetail?.HTSCode) {
        ECCNInfo.push({ Name: 'HTSN', Value: productDetail.HTSCode })
      }
      if (productDetail?.ScheduleBCode) {
        ECCNInfo.push({ Name: 'Schedule B', Value: productDetail.ScheduleBCode })
      }
      setECCNData(ECCNInfo)
    }
  }, [productDetail]);

  const sortAttributes = (columnName) => {
    const Attributes = (columnName === 'Name' || columnName === 'Value') ? [...ECCNData] : [...productData]
    let AttributesSorted = []
    if (ascDesField.hasOwnProperty(columnName)) {
      ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
      setAscDesField(ascDesField)
    } else {
      ascDesField[columnName] = 'ASC'
      setAscDesField(ascDesField)
    }
    setSortBy(columnName)
    if (ascDesField[columnName] === 'ASC') {
      AttributesSorted = Attributes.sort((a, b) => (b[columnName] < a[columnName] ? -1 : 1));
    } else if (ascDesField[columnName] === 'DESC') {
      AttributesSorted = Attributes.sort((a, b) => (b[columnName] > a[columnName] ? -1 : 1));
    }
    // Working Not working, Will continue.
    if (columnName === 'Name' || columnName === 'Value') {
      setECCNData(AttributesSorted)
    } else {
      setProductData(AttributesSorted)
    }
  };

  const getOrderByClass = (columnName) => {
    if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
      return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
    }
    return 'sorting'
  };

  const handleRowCheckboxChange = (row) => {
    setSelectedValues((prevSelectedValues) => {
      const newSelectedValues = { ...prevSelectedValues };
      const rowKey = Helper.anythingToCamel(row.main_label);
      const rowValue = row.value;

      if (newSelectedValues[rowKey]) {
        const valueIndex = newSelectedValues[rowKey].s.findIndex(item => item.value === rowValue);
        if (valueIndex !== -1) {
          newSelectedValues[rowKey].s.splice(valueIndex, 1);
          if (newSelectedValues[rowKey].s.length === 0) {
            delete newSelectedValues[rowKey];
          }
        } else {
          newSelectedValues[rowKey].s.push({ value: rowValue });
        }
      } else {
        newSelectedValues[rowKey] = { s: [{ value: rowValue }], main_label: row.main_label };
      }

      return newSelectedValues;
    });
  };

  const handleSelectAllCheckboxChange = () => {
    if (Object.keys(selectedValues).length === productData.length) {
      setSelectedValues({});
    } else {
      const allValues = productData.reduce((acc, item) => {
        const key = Helper.anythingToCamel(item.ATTRNAME);
        if (!acc[key]) {
          acc[key] = { s: [{ value: item.ATTRVAL }], main_label: item.ATTRNAME };
        } else {
          acc[key].s.push({ value: item.ATTRVAL });
        }
        return acc;
      }, {});
      setSelectedValues(allValues);
    }
  };

  const isAllSelected = Object.keys(selectedValues).length === productData.length;

  return (
    <div className="tab-pane active" id="tab1">
      <div className="productdetail-description">
        {productDetail?.LongDescription && (
          <p className="mob-font-13 mb-2" dangerouslySetInnerHTML={{ __html: productDetail.LongDescription }}></p>
        )}
        {productDetail.ProductFeatures && (
          <p className="mob-font-13 mb-2" dangerouslySetInnerHTML={{ __html: productDetail.ProductFeatures }}></p>
        )}
      </div>

      {productData.length > 0 && (
        <div>
          <h3 className="mb-2 mt-0 lh-normal">{t('technicalAttributes')}</h3>
          <p className="text-sm mb-2">{t('findSimilarParts')}</p>
          <div className="table-responsive">
            <table className="bs5 table table-bordered">
              <thead>
                <tr>
                  <th className="w35 font-12">
                    <div className="form-check d-flex align-items-center font-18">
                      <input
                        type="checkbox"
                        className="form-check-input me-1"
                        checked={isAllSelected}
                        onChange={handleSelectAllCheckboxChange}
                      />
                      <label className="form-check-label" />
                    </div>
                  </th>
                  <th>
                    <span>{t('description')}</span>
                    <span className={'sort-container ' + getOrderByClass('ATTRNAME')} onClick={() => sortAttributes('ATTRNAME')}></span>
                  </th>
                  <th>
                    <span>{t('Value')}</span>
                    <span className={'sort-container ' + getOrderByClass('ATTRVAL')} onClick={() => sortAttributes('ATTRVAL')}></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {productData.map((element, index) => {
                  const row = {
                    key: Helper.anythingToCamel(element.ATTRNAME),
                    main_label: element.ATTRNAME,
                    value: element.ATTRVAL,
                  };

                  return (
                    <tr key={index}>
                      <td>
                        <div className="form-check d-flex align-items-center font-18">
                          <input
                            type="checkbox"
                            className="form-check-input me-1"
                            checked={selectedValues[Helper.anythingToCamel(row.key)] ? true : false}
                            onChange={() => handleRowCheckboxChange(row)}
                          />
                        </div>
                      </td>
                      <td>
                        <label className="form-check-label">{element.ATTRNAME?.trim() || '-'}</label>
                      </td>
                      <td>{element.ATTRVAL?.trim() || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            disabled={Object.keys(selectedValues).length === 0}
            onClick={goToProductListing}
            className={Object.keys(selectedValues).length === 0 ? 'bs5 btn btn-secondary mt-3 mb-3 disabled' : 'bs5 btn btn-secondary mt-3 mb-3'}
          >
            {t('findSimilarParts')}
          </button>
        </div>
      )}

      {ECCNData.length > 0 && (
        <div className="mt-1">
          <h3 className="mb-3 mt-0 lh-normal">ECCN / UNSPSC / COO</h3>
          <div className="table-respnsive">
            <table className="bs5 table table-bordered">
              <thead>
                <tr>
                  <th>
                    <span>{t('description')}</span>
                    <span className={'sort-container ' + getOrderByClass('Name')} onClick={() => sortAttributes('Name')}></span>
                  </th>
                  <th>
                    <span>{t('Value')}</span>
                    <span className={'sort-container ' + getOrderByClass('Value')} onClick={() => sortAttributes('Value')}></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {ECCNData.map((v, i) => (
                  <tr key={i}>
                    <td>{v.Name}:</td>
                    <td>{v.Value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetailDescriptionTab;